import classes from 'components/common/GlobalFilterComponent/GlobalFilterComponent.module.scss';
import { Controller } from 'react-hook-form';
import { MyCustomSelect } from 'components/common/MyCustomSelect/myCustomSelect';
import React, { useEffect } from 'react';
import { useQueryState } from 'hooks/useQueryState';
import { useGlobalFilterDataStore } from 'store/globalFilterData.store';
import produce from 'immer';
import { Range } from 'components/common/GlobalFilterComponent/components/RangeFilter/rangeFilter';
import { FilterLabels } from 'components/common/GlobalFilterComponent/GlobalFilterComponent.utils';

interface Props {
    methods?: any;
    name: string;
    setState?: React.Dispatch<React.SetStateAction<any>>;
    handleFilters?: () => void;
    className?: string;
}

export type ProgressMeasurement =
    | 'activityCompleted'
    | 'activityCompletedCriticality'
    | 'activitySubmittedCompletion'
    | 'activitySubmittedCompletionCriticality'
    | 'resourceUnits';

export const options: ISelectOption<ProgressMeasurement>[] = [
    { label: 'Activities Fully Completed - Equally Weighted', value: 'activityCompleted' },
    { label: 'Activities Fully Completed - Criticality Weighted', value: 'activityCompletedCriticality' },
    { label: 'Activities Fully & Partially Completed - Equally Weighted', value: 'activitySubmittedCompletion' },
    {
        label: 'Activities Fully & Partially Completed - Criticality Weighted',
        value: 'activitySubmittedCompletionCriticality',
    },
    { label: 'Resources - Resource Units Weighted', value: 'resourceUnits' },
];

export const ProgressMeasurementFilter = ({ methods, name, setState, handleFilters, className }: Props) => {
    const [queryStringValue] = useQueryState(name);
    const { getValueFromStore } = useGlobalFilterDataStore();
    const storeValue = getValueFromStore<Range>(name);

    const formValue = methods?.getValues(name);
    const isValue = formValue || queryStringValue || storeValue;

    useEffect(() => {
        if (setState) {
            if (!isValue) {
                setState((prev) => {
                    return produce(prev, (draft) => {
                        draft[name].isReady = true;
                        draft[name].isEmpty = true;
                        return draft;
                    });
                });
            }
            if (isValue) {
                methods?.setValue(name, isValue);
                setState((prev) => {
                    return produce(prev, (draft) => {
                        draft[name].isReady = true;
                        return draft;
                    });
                });
            }
        }
    }, [isValue, setState]);

    const handleChange = (option: ISelectOption<string> | null) => {
        methods?.setValue(name, option ? option.value : null);
        handleFilters && handleFilters();
    };

    const handleValue = (value) => {
        if (!value) {
            return null;
        }
        return options.find((item) => item.value === isValue) || null;
    };
    return (
        <div className={`${classes.selectWrapper} ${className ?? ''}`}>
            <span className={classes.title}>{FilterLabels.progressMeasurement}</span>
            <div className={classes.activityCodesSelectWrapper}>
                <Controller
                    render={({ field }) => (
                        <MyCustomSelect<ISelectOption<ProgressMeasurement>>
                            {...field}
                            options={options}
                            id={'global-filter-component-activity-type'}
                            onChange={handleChange}
                            value={handleValue(field.value)}
                        />
                    )}
                    name={name}
                    control={methods?.control}
                />
            </div>
        </div>
    );
};
